const options = {
  5: "bg-orange-800/5",
  10: "bg-orange-800/10",
  25: "bg-orange-800/25",
  50: "bg-orange-800/50",
  75: "bg-orange-800/75",
  90: "bg-orange-800/90",
  100: "bg-orange-800",
};

const from = {
  5: "from-orange-800/5",
  10: "from-orange-800/10",
  25: "from-orange-800/25",
  50: "from-orange-800/50",
  75: "from-orange-800/75",
  90: "from-orange-800/90",
  100: "from-orange-800",
};

export default function getBackgroundOrange800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
